<div class="container-box">
  <app-table-header tableTitle="Tipo pagamento" (btnUpdateClick)="loadPaymentTypes()">
    <app-button-new-payment-type action-button></app-button-new-payment-type>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="paymentTypesTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
